module.exports = __webpack_public_path__ + "img/hot_title.c290be14.png";